module.exports = __webpack_public_path__ + "img/NP360_VIEW_SMALL.3334cd4b.jpg";